'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _uuid = require('uuid');

var _uuid2 = _interopRequireDefault(_uuid);

var _classnames2 = require('classnames');

var _classnames3 = _interopRequireDefault(_classnames2);

var _FormField = require('./FormField');

var _FormField2 = _interopRequireDefault(_FormField);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TextField = function (_Component) {
  _inherits(TextField, _Component);

  function TextField() {
    _classCallCheck(this, TextField);

    var _this = _possibleConstructorReturn(this, (TextField.__proto__ || Object.getPrototypeOf(TextField)).call(this));

    _this.state = {};
    return _this;
  }

  _createClass(TextField, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          autofocus = _props.autofocus,
          disabled = _props.disabled,
          name = _props.name,
          placeholder = _props.placeholder,
          readonly = _props.readonly,
          defaultValue = _props.defaultValue,
          size = _props.size,
          value = _props.value,
          labelClass = _props.labelClass,
          descriptionClass = _props.descriptionClass,
          controlClass = _props.controlClass,
          errorClass = _props.errorClass,
          hintClass = _props.hintClass,
          hint = _props.hint,
          label = _props.label,
          description = _props.description,
          maxlength = _props.maxlength,
          minlength = _props.minlength,
          pattern = _props.pattern,
          required = _props.required,
          onFocus = _props.onFocus,
          onBlur = _props.onBlur;

      var error = this.props.error || this.state.error;
      var id = this.props.id || _uuid2.default.v1();

      var controlAttrs = {
        autoFocus: autofocus,
        disabled: disabled,
        id: id,
        name: name,
        placeholder: placeholder,
        value: value,
        defaultValue: defaultValue,
        readOnly: readonly,
        size: size,
        maxLength: maxlength,
        minLength: minlength,
        pattern: pattern,
        required: required,
        onChange: this.handleChange.bind(this),
        onInput: this.handleInput.bind(this),
        onInvalid: this.handleInvalid.bind(this),
        onBlur: onBlur,
        onFocus: onFocus,
        className: controlClass
      };

      var fieldAttrs = {
        error: error,
        hint: hint,
        id: id,
        label: label,
        name: name,
        description: description,
        labelClass: labelClass,
        descriptionClass: descriptionClass,
        errorClass: errorClass,
        hintClass: hintClass
      };

      var control = this.props.multiline ? _react2.default.createElement('textarea', _extends({}, controlAttrs, { ref: function ref(el) {
          return _this2.input = el;
        } })) : _react2.default.createElement('input', _extends({}, controlAttrs, { ref: function ref(el) {
          return _this2.input = el;
        } }));

      var className = (0, _classnames3.default)(_defineProperty({
        TextField: true
      }, this.props.className, !!this.props.className));

      return _react2.default.createElement(
        _FormField2.default,
        _extends({ className: className }, fieldAttrs),
        control
      );
    }
  }, {
    key: 'handleInput',
    value: function handleInput(e) {
      if (this.props.onInput) {
        this.props.onInput(e);
      }

      var validate = this.props.validate || this.state.validate;
      if (validate) {
        this.checkError(e);
      }
    }
  }, {
    key: 'handleChange',
    value: function handleChange(e) {
      if (this.props.onChange) {
        this.props.onChange(e);
      }

      var validate = this.props.validate || this.state.validate;
      if (validate) {
        this.checkError(e);
      }
    }
  }, {
    key: 'handleInvalid',
    value: function handleInvalid(e) {
      this.setState({ validate: true });
      this.checkError(e);
    }
  }, {
    key: 'checkError',
    value: function checkError(e) {
      var el = this.input;
      var validity = el.validity;

      this.setState({ error: this.props.validationMessage(validity, el) });
    }
  }]);

  return TextField;
}(_react.Component);

TextField.defaultProps = {
  validationMessage: function validationMessage(validity, el) {
    return el.validationMessage;
  }
};
exports.default = TextField;
//# sourceMappingURL=data:application/json;base64,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


//////////////////
// WEBPACK FOOTER
// ../~/@segment/react-forms/lib/TextField.js
// module id = 1110
// module chunks = 0